import { Alert } from "../../ui/shadcn/alert";
import { Progress } from "../../ui/shadcn/progress";
import { Loader2 } from "../../ui/icons";

interface ProgressIndicatorProps {
  isGenerating: boolean;
  progress: {
    message: string;
    percentage: number;
  };
}

export function ProgressIndicator({
  isGenerating,
  progress,
}: ProgressIndicatorProps) {
  if (isGenerating) {
    return (
      <Alert
        variant="info"
        icon={<Loader2 className="w-5 h-5 animate-spin" />}
      >
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold">{progress.message}</p>
          <Progress value={progress.percentage} className="h-1.5" />
          <p className="text-xs text-gray-600">
            {progress.percentage}% concluído
          </p>
        </div>
      </Alert>
    );
  }

  return null;
}
